import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      dark: {
        primary: "#37394d",
        secondary: "#638cff",
        nsecondary: "#f5487f",
        nwhite: "#f1f1f1",
        adawhite: "#37394d",
        adaprimary: "#f1f1f1",
        accent: "#37394d",
        anchor: "#638cff"
      },
      light: {
        primary: "#37394d",
        secondary: "#638cff",
        nsecondary: "#f5487f",
        nwhite: "#f1f1f1",
        adawhite: "#f1f1f1",
        adaprimary: "#37394d",
        accent: "#f2f2f2",
        anchor: "#638cff"
      }
    }
  }
});
